import React from 'react';
import TextInput from '../../TextInput';

interface IProps {
  name?: string
  appendClass?: string,
  labelName?: string,
  id?: string,
  checked?: boolean,
  onChange?: Function,
  withInput?: boolean,
  setEquipmentQuantity?: any,
  textInputValue?: number,
  disabled?: boolean
}

const FormCheckBox = ({ appendClass = '', ...rest }: IProps) => {
  const {
    name = '',
    labelName = '',
    id,
    checked = false,
    onChange = () => null,
    withInput = false,
    setEquipmentQuantity,
    textInputValue = 0,
    disabled = false,
  } = rest;

  return <div className={`witt-check ${appendClass}`}>
    <div className='custom-control custom-checkbox'>
      <input
        name={name}
        type='checkbox'
        className='custom-control-input'
        id={id + name}
        checked={checked}
        onChange={(e) => onChange(e, id)}
        disabled={disabled}
      />

      {withInput && checked && <div className="qty-wrap">
        {id != '1' && id != '2' && <><label className='qty-txt'>QTY</label>
          <TextInput
            type='number'
            onChange={(e: any) => setEquipmentQuantity(e, id)}
            name={name}
            className={'eqtqty'}
            value={textInputValue}
            disabled={disabled}
          />
        </>}
      </div>}

      <label className='custom-control-label' htmlFor={id + name}>{labelName.toUpperCase()}</label>
    </div>
  </div>
}

export default FormCheckBox;